<template>
  <el-drawer custom-class="drawer-custom-class"
             append-to-body
             :close-on-press-escape="false"
             :title="title"
             size="720px"
             :visible.sync="visible"
             direction="rtl"
             @closed="handleClose">
    <div v-loading="loading"
         class="drawer-wrap">
      <el-form ref="form"
               class="el-form-item__margin-0"
               label-width="90px">
        <el-row v-if="type ===1">
          <el-col :span="24">
            <el-form-item label="出库单号：">
              <div style="font-weight:700">{{info.outstockCode}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="物流单号：">
              <div style="font-weight:700">{{info.courierNumber}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="出库类型：">
              <div style="font-weight:700">{{info.outboundType}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品总数：">
              <div>{{info.outGoodsCount}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="出库时间：">
              <div>{{info.outstockTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-form-item label="退货单号：">
              <div style="font-weight:700">{{info.goodsReturnCode}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="商品总数：">
              <div>{{info.returnGoodsCount}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="退货时间：">
              <div>{{info.goodsReturnTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="table-search-form">
        <el-input placeholder="请输入标签序号" style="width: 240px;"
                  v-model="query.tagNo">
          <el-button slot="append" @click="onSreach"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div> -->
      <el-table border
                height="400"
                :data="list">
        <el-table-column label="商品名称"
                         prop="productName">
        </el-table-column>
        <el-table-column label="商品数量"
                         width="120"
                         prop="goodCount"></el-table-column>
        <el-table-column label="产品码信息"
                         width="120">
          <template slot-scope="{row}">
            <!-- <div v-if="row.setNos">套码: {{row.setNos}}</div>
          <div v-if="row.tagNos">产品码: {{row.tagNos}}</div> -->
            <el-popover placement="right"
                        title="产品码信息"
                        width="560"
                        trigger="click">
              <el-table max-height="300px"
                        :data="row.outstockTagInfos">
                <el-table-column min-width="150"
                                 prop="batchCode"
                                 label="批次号"></el-table-column>
                <el-table-column min-width="100"
                                 prop="formatedSetNo"
                                 label="套码序号"></el-table-column>
                <el-table-column min-width="100"
                                 prop="formatedTagNo"
                                 label="产品码序号"></el-table-column>
                <el-table-column width="100"
                                 prop="outboundType"
                                 label="出库类型"></el-table-column>
                <el-table-column min-width="130"
                                 v-if="hasDigitalId"
                                 prop="digitalId"
                                 label="数证ID"></el-table-column>
              </el-table>
              <el-button type="text"
                         slot="reference">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'product-count-modal',
  data () {
    return { loading: false, visible: false, title: '', type: -1, list: [], info: {}, hasDigitalId: false, query: { tagNo: '' } }
  },
  watch: {
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.list = []
      this.info = {}
      this.hasDigitalId = false
    },
    getoutstock () {
      this.loading = true
      const { outstockId, vendorId } = this.info
      this.$store.dispatch('outstock/getoutstock', {
        payload: { outstockId, vendorId, ...this.query },
        success: (res) => {
          this.loading = false
          res.data.outstockItems.forEach(i => {
            i.goodCount = i.outGoodsCount
            i.tagNos = i.tagNos.join(',')
            i.setNos = i.setNos.join(',')
            let list = []
            i.outstockTagInfos.forEach(s => {
              if (s.isSetcode === 0) {
                list.push({ ...s, formatedSetNo: '' })
              }
              if (s.isSetcode === 1) {
                let formatedTagNo = s.formatedTagNo
                const digitalId = s.digitalId
                if (!this.hasDigitalId) {
                  this.hasDigitalId = !!digitalId
                }
                s.tagNos.forEach(m => {
                  list.push({ ...s, formatedTagNo: m, formatedSetNo: formatedTagNo, digitalId })
                })
              }
            })
            i.outstockTagInfos = list
          })
          this.list = res.data.outstockItems
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getgoodsreturn () {
      this.loading = true
      const { goodsReturnId, vendorId } = this.info
      this.$store.dispatch('goodsreturn/getgoodsreturn', {
        payload: { goodsReturnId, vendorId, ...this.query },
        success: (res) => {
          this.loading = false
          res.data.goodsReturnItems.forEach(i => {
            i.goodCount = i.returnGoodsCount
            i.tagNos = i.tagNos.join(',')
            i.setNos = i.setNos.join(',')
            let list = []
            i.goodsReturnTagInfos = i.goodsReturnTagInfos || []
            i.goodsReturnTagInfos.forEach(s => {
              if (s.isSetcode === 0) {
                list.push({ ...s, formatedSetNo: '' })
              }
              if (s.isSetcode === 1) {
                let formatedTagNo = s.formatedTagNo
                const digitalId = s.digitalId
                if (!this.hasDigitalId) {
                  this.hasDigitalId = !!digitalId
                }
                s.tagNos.forEach(m => {
                  list.push({ ...s, formatedTagNo: m, formatedSetNo: formatedTagNo, digitalId })
                })
              }
            })
            i.outstockTagInfos = list
          })
          this.list = res.data.goodsReturnItems
        },
        fail: (err) => {
          console.log(err)
          this.loading = false
        }
      })
    },
    onSreach () {
      if (this.type === 1) {
        this.getoutstock()
      } else if (this.type === 2) {
        this.getgoodsreturn()
      }
    },
    searchOutstock (row, title) {
      this.toggleModal(true)
      this.info = row
      this.title = title
      this.type = 1
      this.getoutstock()
    },
    searchGoodsreturn (row, title) {
      this.toggleModal(true)
      this.info = row
      this.title = title
      this.type = 2
      this.getgoodsreturn()
    }
  }
}
</script>
<style lang="stylus" scoped>
.table-search-form {
  display: flex;
  align-items: center;
  margin: 15px 0 10px;
  justify-content: flex-end;
}
</style>
